import { render, staticRenderFns } from "./ListApplicant.vue?vue&type=template&id=23b466e1&"
import script from "./ListApplicant.vue?vue&type=script&lang=js&"
export * from "./ListApplicant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports